document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          #email, input[type="email"], input[type="text"] {
            text-transform: none !important;
          }
        `;
        el.shadowRoot.appendChild(style);
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});